module.exports = __webpack_public_path__ + "img/vd-lover-birds.b4a89f69.svg";